import React, { useState } from 'react';
import { Content, Row, Col, Title, Pagination, Button } from 'components';
import { SideMenu } from '../components';
import OrderListTable from '../components/OrderListTable/OrderListTable';
import { Empty, Spin } from 'antd';
import { encrypt } from 'utils/Crypto';
import x_icon from 'assets/svg/x_icon.svg';
import Formatter from 'utils/Formatter';

const PAGE_COUNT = 5;

const MypageSubscribePresenter = (props) => {
  /* ===== Props ===== */
  const {
    order,
    isLoading,
    onOrderStatus,
    navigate,
    tabItem,
    selectedTab,
    setSelectedTab,
    cards,
    onDeleteCard,
    onOpenCardPopup,
    screenSize,
  } = props;

  /* ===== Variables ===== */
  const styles = {
    tabContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    tab: {
      width: screenSize >= 768 ? 160 : 130,
      height: screenSize >= 768 ? 66 : 55,
      lineHeight: screenSize >= 768 ? '66px' : '55px',
      textAlign: 'center',
      cursor: 'pointer',
      fontSize: screenSize >= 768 ? 16 : 14,
      border: '1px solid gray',
      backgroundColor: 'transparent',
      color: 'gray',
    },
    activeTab: {
      fontWeight: 'bold',
      backgroundColor: 'black',
      color: 'white',
      border: '2px solid black',
    },
    emptyState: {
      textAlign: 'center',
      padding: '50px 0',
      fontSize: 16,
      color: 'gray',
    },
    listButton: {
      fontSize: screenSize >= 768 ? 16 : 14,
      fontWeight: 700,
      backgroundColor: 'var(--black-color)',
      color: 'var(--white-color)',
      width: screenSize >= 768 ? 240 : '100%',
      height: screenSize >= 768 ? 64 : 55,
      borderRadius: 4,
    },
  };

  /* ===== State ===== */
  const [currentPage, setCurrentPage] = useState(1); // 현재 페이지

  /* ===== Function ===== */
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  /* ===== Render ===== */
  return (
    <React.Fragment>
      <Spin spinning={isLoading}>
        <Content
          maxWidth={1820}
          padding={screenSize >= 768 ? '120px 0px' : '60px 0'}
        >
          <Row gutter={25}>
            <Col x={0} md={1} xl={2}></Col>
            <Col x={0} md={6} xl={4}>
              <SideMenu />
            </Col>
            <Col x={24} md={16} xl={16}>
              <Content
                maxWidth={'100%'}
                padding={
                  screenSize >= 1200
                    ? '0 0 0 95px'
                    : screenSize >= 768
                    ? '0 0 0 20px'
                    : '0'
                }
              >
                <Content maxWidth={'100%'} padding={0}>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Title
                      style={{
                        fontSize:
                          screenSize >= 768 ? 32 : screenSize >= 500 ? 28 : 20,
                        fontWeight: 700,
                        marginBottom: 24,
                        fontFamily: 'Pretendard',
                      }}
                    >
                      정기배송 설정 관리
                    </Title>
                    <div
                      style={{
                        backgroundColor: '#f4f4f4',
                        padding: '32px 40px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        flexDirection: 'column',
                        marginBottom: 80,
                        color: 'var(--black-color)',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexWrap: 'wrap',
                          justifyContent: 'space-between',
                          alignItems: screenSize >= 1200 ? 'center' : 'unset',
                          flexDirection:
                            screenSize >= 1200 ? 'unset' : 'column',
                          gap: 20,
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 8,
                            width: screenSize >= 1200 ? '70%' : '100%',
                          }}
                        >
                          <span style={{ fontSize: 18, fontWeight: 700 }}>
                            정기배송 결제카드
                          </span>
                          <span style={{ lineHeight: 1.75 }}>
                            정기배송 결제에 사용될 카드를 등록해 주세요.
                            결제수단이 등록되어 있을 경우 빠른 신청이
                            가능합니다. <br />
                            결제예정일 (주기별 배송시작일 하루 전)에 결제 정보로
                            정기배송 상품이 결제됩니다.
                          </span>
                        </div>
                        <Button
                          style={styles.listButton}
                          onClick={() => onOpenCardPopup('SUBSCRIPTION')}
                        >
                          카드 등록하기
                        </Button>
                      </div>

                      {/* 등록된 카드 목록 */}
                      {cards.length ? (
                        <div className="card_list" style={{ marginTop: 20 }}>
                          <span
                            style={{
                              fontSize: 18,
                              fontWeight: 700,
                            }}
                          >
                            등록된 카드
                          </span>
                          {cards.map((card) => (
                            <div
                              key={`card-${card.card_id}`}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 10,
                                marginTop: 10,
                              }}
                            >
                              <span
                                style={{
                                  fontSize: 14,
                                  color: 'var(--dark-gray-color)',
                                  wordBreak: 'keep-all',
                                }}
                              >
                                {card.card_company} (
                                {Formatter.hyphen(
                                  card.card_number,
                                  'card',
                                  true
                                )}
                                )
                              </span>
                              <p
                                style={{
                                  fontSize: 14,
                                  color: 'var(--dark-gray-color)',
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                결제 {card.subscribe.length}건
                              </p>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 5,
                                }}
                              >
                                <img
                                  src={x_icon}
                                  alt="삭제"
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => onDeleteCard(card)}
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : null}

                      {/* 등록된 카드 목록 끝 */}
                    </div>

                    {/* Tabs */}
                    <div
                      style={{
                        ...styles.tabContainer,
                        borderBottom:
                          order.length === 0
                            ? '2px solid var(--black-color)'
                            : 'none',
                      }}
                    >
                      {tabItem.map((tab) => (
                        <div
                          key={`tab-${tab.value}`}
                          style={{
                            ...styles.tab,
                            ...(selectedTab === tab.value
                              ? styles.activeTab
                              : {}),
                          }}
                          onClick={() => {
                            setSelectedTab(tab.value);
                            setCurrentPage(1); // 탭 변경 시 페이지를 초기화
                          }}
                        >
                          {tab.label}
                        </div>
                      ))}
                    </div>
                  </div>
                  {/* 주문 목록 테이블 */}
                  <div>
                    {order.length ? (
                      order
                        .slice(
                          (currentPage - 1) * PAGE_COUNT,
                          currentPage * PAGE_COUNT
                        )
                        .map((group, index) => (
                          <OrderListTable
                            key={`shop-regular-order-${group.shop_order_id}`}
                            orders={[group]}
                            detailText="주문상세"
                            showExpectedCycle={true}
                            onDetailClick={(state) =>
                              navigate(
                                `/mypage/order/${encodeURIComponent(
                                  encrypt(state.shop_order_id)
                                )}`
                              )
                            }
                            onSubmit={onOrderStatus}
                          />
                        ))
                    ) : (
                      <div style={styles.emptyState}>
                        <Empty description={'주문 내역이 없습니다.'} />
                      </div>
                    )}
                  </div>
                </Content>
                {/* 페이지네이션 */}
                <Content
                  maxWidth={'100%'}
                  padding={0}
                  style={{ marginTop: screenSize >= 768 ? 100 : 60 }}
                >
                  <Pagination
                    total={order.length}
                    pageSize={PAGE_COUNT}
                    current={currentPage}
                    onChange={handlePageChange}
                    showPage={5}
                    buttonStyle={{
                      fontSize: 16,
                      fontWeight: 700,
                      color: '#999999',
                      background: 'none',
                      width: 28,
                      height: 28,
                    }}
                    isButton={true}
                    activeStyle={{
                      color: `var(--black-color) !important`,
                      borderBottom: '2px solid #111111',
                    }}
                    hoverStyle={{ color: `var(--black-color) !important` }}
                    navStyle={{ border: '1px solid var(--black-color)' }}
                    isLatestButton={true}
                  />
                </Content>
              </Content>
            </Col>
            <Col x={0} md={1} xl={2}></Col>
          </Row>
        </Content>
      </Spin>
    </React.Fragment>
  );
};

export default MypageSubscribePresenter;
